define('meetings/meetings',['require','knockout','plugins/router','i18next','api-access','api-access','video-player-modal/video-player-modal','lib/check-first-visit','lib/multivariate-testing/multivariate-testing'],function (require) {
    var ko = require('knockout');
    var router = require('plugins/router');
    var i18n = require('i18next');
    var gotomeetApi = require('api-access').gotomeet;
    var userApi = require('api-access').user;
    var videoPlayerModal = require('video-player-modal/video-player-modal');
    var checkFirstVisit = require('lib/check-first-visit');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');

    var self = this;

    var isVideoPlayed = false;
    self.welcomeMsg = ko.observable();
    self.showWelcomeMsg = ko.observable();
    self.upcomingMenuText = ko.observable();
    self.isUpcomingMenuScheduleButtonVisible = ko.observable();
    self.shiftMenuTabs = ko.observable();
    self.primaryScheduler = ko.observable();
    self.composeJoinLink = ko.observable();

    /**
     * Route Config
     *
     * nav: Will add route to Durandal navigation model.
     * meetingsMenuText: If given a string, will display that as a link in the meetings-menu.
     * showCornerJoinLink: Boolean that determines if the secondary corner join link can show up.
     *
     * For all changes to the routing, there should be a corresponding change in the tracking!
     */
    self.meetingsRouter = router.createChildRouter()
        .makeRelative({
            moduleId: 'meetings',
            fromParent: true
        })
        .map([
            {
                route: ['upcoming', ''],
                hash: '#meetings/upcoming',
                moduleId: 'upcoming-meetings/upcoming-meetings',
                nav: true,
                title: i18n.t('myMeetings.selection.upcoming'),
                meetingsMenuText: self.upcomingMenuText,
                isMenuScheduleButtonVisible: self.isUpcomingMenuScheduleButtonVisible,
                showCornerJoinLink: true
            },
            {
                route: 'past',
                hash: '#meetings/past',
                moduleId: 'meeting-history/meeting-history',
                nav: true,
                title: i18n.t('myMeetings.selection.past'),
                meetingsMenuText: i18n.t('myMeetings.selection.past'),
                isMenuScheduleButtonVisible: false
            }
        ])
        .buildNavigationModel();

    function activate() {
        userApi.me().then(function (user) {
            self.welcomeMsg(i18n.t('welcome.title') + ' ' + user.firstName + '!');
        });

        gotomeetApi.getByUserKey().then(function (profile) {
            self.showWelcomeMsg(!profile.profileId);
            self.composeJoinLink(!!profile.profileId);
        }).fail(function () {
            self.showWelcomeMsg(true);
            self.composeJoinLink(false);
        });

        return multivariateTesting.checkVariation('g2mmSchedulingTest').then(function (variation) {
            if (variation === 'variation-a') {
                self.upcomingMenuText('More Rooms');
                self.isUpcomingMenuScheduleButtonVisible(true);
                self.shiftMenuTabs(true);
                self.primaryScheduler('meetings/action-center/action-center');

                checkFirstVisit.check().then(function (isFirstLogin) {
                    if (isFirstLogin && !isVideoPlayed) {
                        videoPlayerModal.show();
                        isVideoPlayed = true;
                    }
                });
            } else {
                self.upcomingMenuText(i18n.t('myMeetings.selection.upcoming'));
                self.isUpcomingMenuScheduleButtonVisible(false);
                self.shiftMenuTabs(false);
                self.primaryScheduler('meetings/meetings-header/meetings-header');
            }
        });
    }

    return {
        router: self.meetingsRouter,
        activate: activate
    };
});

